export default __webpack_public_path__ + "static/media/Discord.a7364ad9.svg";